import React from 'react';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Variant } from '@material-ui/core/styles/createTypography';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
    margined: {
      '& b, & u': {
        margin: '0 4px',
      },
    },
  }),
);

interface Props {
  variant?: Variant | 'inherit';
  className?: string;
  align?: 'left' | 'right' | 'inherit' | 'center' | 'justify';
  margined?: boolean;
  style?: React.CSSProperties;
}

const Subtitle: React.FC<Props> = ({ children, variant = 'subtitle1', className, align, margined, style }) => {
  const classes = useStyles();

  return (
    <Typography
      variant={variant}
      component="p"
      align={align}
      className={clsx(classes.root, className, margined ? classes.margined : '')}
      style={style}
    >
      {children}
    </Typography>
  );
};

export default Subtitle;
